import store from '@/store/index'
export default {
  openChat (state, payload) {
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === parseInt(payload)) {
        windown.is_open = true
      }
    })
  },
  closeChat (state, payload) {
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === parseInt(payload)) {
        windown.is_open = false
      }
    })
  },
  sendMessage (state, payload) {
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === parseInt(payload.chanel_id)) {
        windown.messageList.push(payload.message)
      }
    })
  },
  receiveMessage (state, payload) {
    var data = {}
    switch (payload.type) {
      case 'file':
        data = { type: 'file', author: payload.user.id + '', data: {text: payload.data.text, file: payload.data.extra} }
        break
      case 'image':
        data = { type: 'image', author: payload.user.id + '', data: {text: payload.data.text, file: payload.data.extra} }
        break
      default:
        data = { type: 'text', author: payload.user.id + '', data: {text: payload.data.text, file: payload.data.extra} }
        break
    }
    store.dispatch('Chat/insertNewWindownChat', payload.user)
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === parseInt(payload.user.id)) {
        windown.messageList.push(data)
      }
    })
  },
  insertNewWindownChat (state, payload) {
    var isset = false
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === parseInt(payload.id)) {
        if (!windown.is_open) {
          windown.is_open = true
        }
        isset = true
      }
    })
    if (isset) {

    } else {
      var data = {}
      data.chanel_id = payload.id
      data.messageList = []
      data.is_open = true
      data.participants = [
        {
          id: payload.id + '',
          name: payload.fullname,
          imageUrl: payload.avatar500x500
        }
      ]
      state.windown_chats.unshift(data)
    }
  },
  removeMessage (state, payload) {
    state.messageList = []
  },
  chatSystem (state, payload) {
    var data = { type: 'text', author: 0 + '', data: {text: payload.response, file: ''} }
    state.windown_chats.forEach(windown => {
      if (parseInt(windown.chanel_id) === 0) {
        windown.messageList.push(data)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/chat/mutations.js